<template lang="pug">
.d-flex.align-center.py-16
  v-container(fluid)
    v-row
      v-col
        v-row(justify="center" align="center")
          transition(name="fade" mode="out-in")
            v-col.text-md-center(cols="auto" :key="items[page].title")
              h3.mx-2.mb-3.ibm.text-h4.text-md-h3.primary--text {{ items[page].title }}
              .mx-2.mb-2.text-body-1.text-sm-h6.heebo.grey--text.text--darken-1 {{ items[page].description }}
        v-row(justify="center" align="center")
          v-col(cols=12 md=8)
            carousel(
              v-model="page"
              navigationNextLabel=""
              navigationPrevLabel=""
              paginationColor="#BDBDBD"
              :autoplay="false"
              :autoplayHoverPause="true"
              :perPage="1"
              :navigationEnabled="$vuetify.breakpoint.mdAndUp"
              :paginationActiveColor="$vuetify.theme.currentTheme.primary.base"
            )
              slide(v-for="(item, i) in items" :key="i")
                .d-flex.align-center.justify-center(style="height: 100%")
                  v-img.rounded-lg(
                    :src="item.image"
                    eager
                    contain
                    style="border: 1px solid #bdbdbd"
                    :max-width="$vuetify.breakpoint.mdAndUp ? '60vw' : '90vw'"
                  )
                    //- :aspect-ratio="16 / 9"
</template>

<script>
export default {
  components: {},
  data() {
    return {
      page: 0,
      items: [
        {
          title: 'Acabe com as limitações físicas',
          description:
            'Chega de se preocupar com aluguel de salas ou limite de alunos',
          image: require('../../assets/SliderNoLimits/no-limits.png')
        },
        {
          title: 'Faça eventos e aulões online',
          description:
            'Venda e realize seus eventos ao vivo diretamente no Erudio',
          image: require('../../assets/SliderNoLimits/events.png')
        },
        {
          title: 'Controle suas finanças',
          description:
            'Acompanhe seus ganhos segmentados por cursos e receba diretamente na sua conta bancária',
          image: require('../../assets/SliderNoLimits/finances-control.png')
        },
        {
          title: 'Acompanhe o desempenho dos seus alunos',
          description:
            'Veja em tempo real a quantidade e o engajamento dos seus alunos',
          image: require('../../assets/SliderNoLimits/monitoring.png')
        },
        {
          title: 'Uma plataforma fácil, rápida e prática',
          description:
            'Tenha uma plataforma de venda de cursos personalizada com a sua marca',
          image: require('../../assets/SliderNoLimits/easy-and-fast.png')
        }
      ]
    }
  }
}
</script>

<style lang="sass" scoped></style>
